/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemDashboardDeviceCustomersModel } from '../../models/system-dashboard-device-customers-model';

export interface SystemDashboardCustomersGet$Params {
  from?: string;
  to?: string;
  allRegions?: boolean;
  integratedSystemId?: string;
  organizationId?: string;
}

export function systemDashboardCustomersGet(http: HttpClient, rootUrl: string, params?: SystemDashboardCustomersGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<SystemDashboardDeviceCustomersModel>> {
  const rb = new RequestBuilder(rootUrl, systemDashboardCustomersGet.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('allRegions', params.allRegions, {});
    rb.query('integratedSystemId', params.integratedSystemId, {});
    rb.query('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<SystemDashboardDeviceCustomersModel>;
    })
  );
}

systemDashboardCustomersGet.PATH = '/SystemDashboard/Customers';
